import { useRef } from 'react';

import { Stopwatch } from '@dreryk/react-components';

import { visitTranslationKeys } from '../../translations';

type VisitStopwatchProps = {
   readonly beginDate: Date;
};

export const VisitStopwatch = (props: VisitStopwatchProps): JSX.Element => {
   const { current: initialTimeInMs } = useRef(Date.now() - new Date(props.beginDate).getTime());

   return (
      <Stopwatch testId={'stopwatch'} initialTimeInMs={initialTimeInMs} label={visitTranslationKeys.stopwatch.label} />
   );
};
